module.exports = __webpack_public_path__ + "img/landing-pic.685beeb0.png";